module.exports = __webpack_public_path__ + "static/media/20240130082536_IMG_5065 (1).c56ca3df.jpg";